import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { awsConfig } from '../../config_cognito';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {

  constructor() { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const userPoolWebClientId = awsConfig.Auth.userPoolWebClientId;

    const email = localStorage.getItem(`CognitoIdentityServiceProvider.${userPoolWebClientId}.LastAuthUser`);
    const token = localStorage.getItem(`CognitoIdentityServiceProvider.${userPoolWebClientId}.${email}.idToken`);
    const refreshToken = localStorage.getItem(`CognitoIdentityServiceProvider.${userPoolWebClientId}.${email}.refreshToken`);

    if (token || refreshToken) {
      const headers = new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set('Authorization', `Bearer ${token}`);
      req = req.clone({ headers });
    }

    return next.handle(req);
  }
}
